import React, { useState, useEffect } from "react";
import CountryNavbar from "../Country/CountryNavbar";
import CountryNavbarMobile from "../Country/CountryNavbarMobile";
import ThanksSection from "./ThanksSection";
import HomeBottomLast from "../Home/HomeBottomLast";
import { connect } from "react-redux";
import changeDetails from "../../store/Actions/DetailsAction";
import changeLogin from "../../store/Actions/LoginAction";
import { paymentConfirmationApi } from "../../config/paymentConfirmationApi";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";
import moment from "moment";


import { useLocation, useHistory, Link } from "react-router-dom";
import queryString from "query-string";
import { confirmPayment } from "../../config/confirmPayment";
// import { ApplicationByIdApi } from "../../config/ApplicationByIdApi";



function Thanks(props) {


  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [application_id, setApplication_id] = useState("");

  const [first, setFirst] = useState("")
  const [second, setSecond] = useState("")
  const [third, setThird] = useState("")

  const { search } = useLocation();
  const { provider, trxref, tx_ref } = queryString.parse(search);

  const history = useHistory();

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }
      props.ChangeLogin(true);

      if(provider !== undefined){
          const confirmIt = async (token) => {
            const confirm = await confirmPayment(token, provider, search);
            if(confirm.data){
                console.log(confirm.data)
                setApplication_id(confirm.data.data.application_id)
                setLoading(false)
                console.log(confirm.data.data.application)
                
                const myDate = new Date(confirm.data.data.application.visa_package.created_at);
                const add = myDate.setDate(myDate.getDate() + confirm.data.data.application.visa_package.processing_time.min)
                const myDate1 = new Date(confirm.data.data.application.visa_package.created_at);
                const addMore = myDate1.setDate(myDate1.getDate() + confirm.data.data.application.visa_package.processing_time.max)
                
                const date1 = moment(new Date(add));
                const firstDate = date1.format("Do MMM");
                setFirst(firstDate)

                setSecond(confirm.data.data.application.visa_package.processing_time.min);

                const date2 = moment(new Date(addMore));
                const thirdDate = date2.format("Do MMM");
                setThird(thirdDate)
            }
            else if(confirm.error){
                console.log(confirm.error)
                history.push('/')
            }

        }
        confirmIt(item.value.token)
        }
        else{
          history.push('/')
        }

    }
    getWithExpiry("userData");

    document.title = "VisaPro | ThankYou";
  }, []);
  
  if (loading) {
    return (
      <div style={{ heigth: "100vh" }}>
        <CountryNavbar countryName={"Loading..."} login={props.login} />
        <div
          style={{
            height: "70vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress style={{ color: "#000000" }} />
        </div>
        <ToastContainer
          transition={Slide}
          position="bottom-left"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover={false}
        />
      </div>
    );
  }

  return (
    <div>
      <CountryNavbar countryName={"Thank You"} login={props.login} />
      <ThanksSection application_id={application_id} first={first} second={second} third={third} />
      <HomeBottomLast />
    </div>
  );
}

const mapStateToProps = (state) => ({
  details: state.Details.details,
  login: state.Login.login,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeLogin: (login) => dispatch(changeLogin(login)),
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(Thanks);
